import { ELocationTypeId, IOfferCard } from '../../../../types/card';
import { prepareUnderground } from './prepareUnderground';
import { prepareRailway } from './prepareRailway';
import { prepareJk } from './prepareJk';
import { IGeoLabel } from '../../../../types/geo';

export const prepareGeo = (offerCard: IOfferCard) => {
  const { geo } = offerCard;

  if (!geo) {
    return null;
  }

  const isGeoAddressWithMetro = geo.address.find(({ type }) => type === 'metro');

  const cityIndex = geo.address.findIndex(({ locationTypeId }) => locationTypeId === ELocationTypeId.City);

  const geoLabels = geo.address.map(
    ({ fullName, type }) =>
      ({
        label: fullName,
        type: type === 'metro' ? 'metro' : 'address',
      }) as IGeoLabel,
  );

  const underground = prepareUnderground(offerCard);

  /**
   * Если есть underground, но нет метро внутри geo.address,
   * то добавляем метро вручную тут
   */
  if (underground && !isGeoAddressWithMetro) {
    const startIndex = cityIndex === -1 ? 1 : cityIndex + 1;

    geoLabels.splice(startIndex, 0, {
      label: `м.\u00A0${underground.name}`,
      type: 'metro',
    });
  }

  return {
    geoLabels,
    regionId: geo.address[0].id,
    jk: prepareJk(offerCard),
    underground,
    railway: !underground ? prepareRailway(offerCard) : undefined,
  };
};
